import { useState } from "react";
import { useNavigate, useParams } from "react-router";
import { filterSurveyStatus } from ".";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import {
  useApproveSurveyMutation,
  useDeclineSurveyMutation,
  useGetFinanceSurveyByIdQuery,
} from "../../../../api/financeApi";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageStyle from "../../../Components/Layout/PageLayout";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import { ActionButtons } from "../../../../global/components/Buttons/buttons";
import FeedbackApproveModal from "./Modal/ApprovalModal";
import { SurveyDeclineModal } from "./Modal/DeclineModal";
import toast from "react-hot-toast";

const AdministrativeViewSurvey = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [openApproveModal, setOpenApproveModal] = useState(false);
  const [openDeclineModal, setOpenDeclineModal] = useState(false);
  const [comment, setComment] = useState("");
  const handleComment = (e) => {
    setComment(e.target.value);
  };
  const { data } = useGetFinanceSurveyByIdQuery(id);
  const handleApproveModal = () => setOpenApproveModal(!openApproveModal);
  const handleDeclineModal = () => setOpenDeclineModal(!openDeclineModal);
  const [onApprove, { isLoading: approving }] = useApproveSurveyMutation();
  const [onDecline, { isLoading: declining }] = useDeclineSurveyMutation();
  const actionButton = (
    <div>
      <div className={DashboardStyle.button_cage}>
        <ActionButtons
          width={"auto"}
          className={DashboardStyle?.button_cage_weight}
          style={{ backgroundColor: "red" }}
          onClick={handleDeclineModal}
          type="button"
        >
          Decline
        </ActionButtons>
        <button
          width={"auto"}
          className={`bg-[#305F32]  rounded-md px-5 py-4 text-[#FCFCFC]`}
          onClick={handleApproveModal}
          type="button"
        >
          Approve
        </button>
      </div>
    </div>
  );
  const itemType = (type) => {
    switch (type) {
      case 4:
        return "text";
      case 5:
        return "textarea";
      case 2:
        return "radio";
      case 1:
        return "checkbox";
      case 3:
        return "rating";
      default:
        return "";
    }
  };
  const handleApprovalSubmit = async () => {
    try {
      const surveyApprovalPayload = {
        id: parseInt(id),
        comment
      };
      const response = await onApprove(surveyApprovalPayload).unwrap();
      if (response?.successful) {
        navigate(-1);
        toast.success(response?.statusMessage);
      }
    } catch (error) {
      toast.error(error?.data?.statusMessage);
      console.error("Error updating survey:", error);
    }
  };
  const handleDeclineSubmit = async () => {
    try {
      const surveyDeclinePayload = {
          id:parseInt(id),
        comment
      };
      const response = await onDecline(surveyDeclinePayload).unwrap();
      if (response?.successful) {
        navigate(-1);
        toast.success(response?.statusMessage);
      }
    } catch (error) {
      toast.error(error?.data?.statusMessage);
      console.error("Error updating survey:", error);
    }
  };
  return (
    <RouteLayout navHidden={true}>
      <PageStyle
        hasBack={true}
        demoTitle={"Feedback Survey Details"}
        hasTopPageDemo
        action={actionButton}
      >
        <div className={DashboardStyle.view_app_components}>
          <section
            style={{
              backgroundColor: "#F8FBF8",
              border: "1px solid #D9E9DA",
              borderRadius: "8px",
            }}
            className={DashboardStyle.form_section}
          >
            <h4 className={DashboardStyle.form_section_title}>
              Process Information
            </h4>
            <div className={DashboardStyle.labels_group}>
              <div>
                <div>
                  <p>Process Type:</p>
                  <h4>Field Survey</h4>
                </div>
                <div>
                  <p>Date Requested:</p>
                  <h4>{FormatDateTime(data?.result?.createdDate)}</h4>
                </div>
                <div>
                  <p>Approval Status:</p>
                  <h4>
                    {filterSurveyStatus.filter(
                      (item) => item.id === data?.result?.approvalStatus,
                    )?.name || "N/A"}
                  </h4>
                </div>
              </div>
              <div>
                <div>
                  <p>Requested By:</p>
                  {/* <h4>{data?.responseObject?.requestorName}</h4> */}
                </div>
                {/* <div>
                                      <p>Employee Group:</p>
                                      <h4>{request?.employeeGroup?.title}</h4>
                                    </div> */}
              </div>
            </div>
          </section>
          {data?.result?.questions?.map((item, index) => (
            <section
              key={index + 1}
              style={{
                backgroundColor: "#F8FBF8",
                border: "1px solid #D9E9DA",
                borderRadius: "8px",
              }}
              className={DashboardStyle.form_section}
            >
              <h4 className={DashboardStyle.form_section_title}>
                Question {index + 1}
              </h4>
              <div className={DashboardStyle.labels_group}>
                <div>
                  <div>
                    <p>Question Type:</p>
                    <h4>{itemType(item?.questionType)}</h4>
                  </div>
                  <div>
                    <p>Maximum Character:</p>
                    <h4>{item?.displayOrder}</h4>
                  </div>
                  <div>
                    <p>Compulsory:</p>
                    <h4>{item.isRequired ? "Yes" : "No"}</h4>
                  </div>
                </div>
                <div>
                  <div>
                    <p>Question:</p>
                    <h4>{item?.questionText}</h4>
                  </div>
                </div>
                {item?.questionType === 3 &&
                  item.options?.length > 0 &&
                  item?.options.map((opt, idx) => (
                    <div key={idx}>
                      <div>
                        <p>Options:</p>
                        <h4>{opt?.optionText}</h4>
                      </div>
                    </div>
                  ))}
              </div>
            </section>
          ))}
        </div>
      </PageStyle>
      <FeedbackApproveModal
        isOpen={openApproveModal}
        handleClose={handleApproveModal}
        handleDelete={handleApprovalSubmit}
        handleComment={handleComment}
        isLoading={approving}
        hasComment
        headText={"Approve Feedback Survey"}
      />
      <SurveyDeclineModal
        openModal={openDeclineModal}
        closeModal={handleDeclineModal}
        handleComment={handleComment}
        handleDelete={handleDeclineSubmit}
        isLoading={declining}
      />
    </RouteLayout>
  );
};

export { AdministrativeViewSurvey };
